import { avisosGet } from "./avisosService"

export const getAviso = async (avisoId) => {
    try {
        const data = await avisosGet()

        if (data) {
            //console.log('data training: ', data)

            console.log(`data ${avisoId}`, data.filter((a) => a.id == avisoId));

            return data.filter((a) => a.id == avisoId)[0]


        }

        return null;
    } catch (error) {
        console.error('error training: ', error)
    }
}